import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "poster-container"
};
const _hoisted_2 = {
  key: 0,
  class: "mask"
};
const _hoisted_3 = {
  class: "mask-button-list ab-center"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "bottom-content"
};
const _hoisted_6 = {
  key: 0,
  class: "price"
};
import "./listCard.less";
export default /*#__PURE__*/_defineComponent({
  __name: 'hallCard',
  props: {
    cardData: {
      default: {}
    },
    btn: {
      default: () => [""]
    }
  },
  emits: ["use", "active"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const showMask = ref(false);
    const router = useRouter();
    const {
      cardData,
      btn
    } = toRefs(props);
    const handleDetails = () => {
      router.push({
        path: "/workplace/hall/hallDetails/" + cardData.value.id
      });
    };
    const handleEdit = () => {
      if (cardData.value.authority && cardData.value.authority == 1) {
        router.push({
          path: "/workplace/hall/createHall",
          query: {
            id: cardData.value.id,
            edit: 0
          }
        });
      } else {
        router.push({
          path: "/workplace/hall/createHall",
          query: {
            id: cardData.value.id
          }
        });
      }
    };
    watch(showMask, val => {
      if (val) {
        emit("active", {
          cardData,
          val
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", {
        class: "list-card",
        onMouseover: _cache[0] || (_cache[0] = $event => showMask.value = true),
        onMouseleave: _cache[1] || (_cache[1] = $event => showMask.value = false)
      }, [_renderSlot(_ctx.$slots, "header"), _createElementVNode("div", _hoisted_1, [_unref(showMask) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(btn).includes('edit') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        round: "",
        onClick: handleEdit
      }, {
        default: _withCtx(() => [_createTextVNode("编辑")]),
        _: 1
      })) : _createCommentVNode("", true), _unref(btn).includes('info') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        round: "",
        onClick: handleEdit
      }, {
        default: _withCtx(() => [_createTextVNode("查看")]),
        _: 1
      })) : _createCommentVNode("", true), _unref(btn).includes('details') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        type: "primary",
        round: "",
        onClick: handleDetails
      }, {
        default: _withCtx(() => [_createTextVNode("详情")]),
        _: 1
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("img", {
        src: _unref(cardData).cover || _unref(cardData).coverImageUrl || require('@/assets/img/icons/exbitionCard-default.png'),
        class: "poster"
      }, null, 8, _hoisted_4)]), _createElementVNode("p", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_unref(cardData).name), 1), _unref(cardData).lowestPrice !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_6, "￥" + _toDisplayString(_unref(cardData).lowestPrice), 1)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "default")], 32);
    };
  }
});